<template>
  <section class="py-9 tablet:py-20">
    <div class="container-wrap">
      <div class="mb-4 desktop:mb-0">
        <div class="desktop:flex desktop:items-center desktop:gap-6">
          <div class="desktop:w-1/3">
            <h2 class="text-h2 mb-10 tablet:line-clamp-2">
              {{ title }}
            </h2>
            <TheRichText
              v-if="descriptionHtml || description"
              class="mb-6 w-full text-sm leading-6 text-gray-700 tablet:mb-10 tablet:line-clamp-7 tablet:text-base"
              :text="descriptionHtml || description"
              :is-html="!!descriptionHtml"
            />

            <div v-if="isDesktop" class="flex flex-col gap-4">
              <TheButton
                v-if="button01?.text"
                :id="button01?.trackingCode"
                :to="button01.link"
                :title="button01.text"
                class="w-full"
              >
                <span class="font-bold">
                  {{ button01.text }}
                </span>
              </TheButton>
              <TheButton
                v-if="button02?.text"
                :id="button02?.trackingCode"
                :to="button02.link"
                :title="button02.text"
                type="outline"
                class="w-full"
              >
                <span class="font-bold">
                  {{ button02.text }}
                </span>
              </TheButton>
            </div>
          </div>
          <div class="desktop:w-2/3">
            <TheMedia
              :title="title"
              :description="description"
              :video-data="wistiaCode ? video : undefined"
              :thumbnail="thumbnail"
              :theme="theme"
              class="aspect-video w-full rounded-3xl"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!isDesktop"
        class="flex flex-col gap-4 tablet:flex-row tablet:justify-center"
      >
        <TheButton
          v-if="button01?.text"
          :id="button01?.trackingCode"
          :to="button01.link"
          :title="button01.text"
          class="w-full tablet:w-60"
        >
          <span class="font-bold">
            {{ button01.text }}
          </span>
        </TheButton>
        <TheButton
          v-if="button02?.text"
          :id="button02?.trackingCode"
          :to="button02.link"
          :title="button02.text"
          type="outline"
          class="w-full tablet:w-60"
        >
          <span class="font-bold">
            {{ button02.text }}
          </span>
        </TheButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=12814-34163&t=89PIFDiQEC4zcSbf-0
   */

  import type { IButton, TTheme } from '@/assets/types/Main.global';
  import type { IVideoData } from '@/components/Shared/Lightbox/Video.vue';

  interface IProps {
    title: string;
    description?: string;
    descriptionHtml?: string;
    thumbnail: string;
    wistiaCode?: string;
    button01?: IButton | null;
    button02?: IButton | null;
    theme?: TTheme;
  }

  const props = withDefaults(defineProps<IProps>(), {
    description: '',
    descriptionHtml: '',
    wistiaCode: '',
    button01: null,
    button02: null,
    theme: 'blue',
  });

  const { isDesktop } = useScreen();

  const video = computed(
    (): IVideoData => ({
      title: props.title,
      description: props.description,
      url: props.wistiaCode,
      imageUrl: props.thumbnail,
    })
  );
</script>
